<template>
    <div class="skeleton-card">
      <div class="skeleton-title shimmer" />
      <div class="skeleton-badge shimmer" />
      <div class="skeleton-line shimmer" style="width: 70%" />
      <div class="skeleton-line shimmer" style="width: 60%" />
      <div class="skeleton-line shimmer" style="width: 80%" />
      <div class="skeleton-line shimmer" style="width: 50%" />
      <div class="skeleton-button shimmer" />
    </div>
  </template>
  
  <style scoped>
  .skeleton-card {
    width: 100%;
    max-width: 660px;
    padding: 32px;
    border-radius: 24px;
    background: linear-gradient(to bottom right, #f9f9f9, #f1f1f1);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 24px;
  }
  
  html[data-theme="dark"] .skeleton-card {
    background: #1e1e1e;
  }
  
  .skeleton-title,
  .skeleton-badge,
  .skeleton-line,
  .skeleton-button {
    height: 18px;
    border-radius: 10px;
    background-color: #e0e0e0;
  }
  
  .skeleton-title {
    width: 120px;
    height: 22px;
  }
  
  .skeleton-badge {
    width: 60px;
    height: 16px;
    border-radius: 8px;
  }
  
  .skeleton-line {
    height: 16px;
  }
  
  .skeleton-button {
    margin-top: 16px;
    width: 120px;
    height: 32px;
    border-radius: 20px;
  }
  
  html[data-theme="dark"] .skeleton-title,
  html[data-theme="dark"] .skeleton-badge,
  html[data-theme="dark"] .skeleton-line,
  html[data-theme="dark"] .skeleton-button {
    background-color: #333;
  }
  
  .shimmer {
    animation: shimmer 1.4s infinite linear;
    background: linear-gradient(
      to right,
      rgba(220, 220, 220, 0.1) 0%,
      rgba(200, 200, 200, 0.3) 50%,
      rgba(220, 220, 220, 0.1) 100%
    );
    background-size: 200% 100%;
  }
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
  </style>